<template>
	<nio-address-list
		ref="nioAddressList"
		:show="show"
		@update:show="v => $emit('update:show', v)"
		:clickOverlay="clickOverlay"
		:province="provinceData"
		:city="cityData"
		:tabList="[0, 1]"
		@selectAddress="handleSelect"
	></nio-address-list>
</template>
<script>
import { registerCityModal } from '@/model'

export default {
	name: 'address-list',
	props: {
		show: {
			type: Boolean,
			default: true
		},
		value: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			clickOverlay: true,

			regionData: [],
			provinceData: {
				content: '',
				default: '请选择省份',
				list: [],
				origin: null
			},
			cityData: {
				content: '',
				default: '请选择城市',
				list: [],
				origin: null
			}
		}
	},
	computed: {},
	created() {
		this.fetchRegion()
	},
	methods: {
		handleSelect({ index, item }) {
			if (index === 0) {
				this.provinceData.content = item

				const curProvince = this.regionData.find(p => p.name === item)
				this.provinceData.origin = curProvince

				this.cityData.list = curProvince.cities.map(c => c.name)
				this.cityData.content = ''
			} else if (index === 1) {
				this.cityData.content = item

				this.cityData.origin = this.provinceData.origin.cities.find(c => c.name === item)

				this.$emit('input', {
					province: { ...this.provinceData.origin },
					city: { ...this.cityData.origin }
				})
			}
		},
		async fetchRegion() {
			try {
				const {
					data: { data: provinces }
				} = await registerCityModal.get({})

				this.regionData = provinces
				this.provinceData.list = provinces.map(p => p.name)
				provinces.forEach(({ area_code, name, cities }) => {
					if (this.value && this.value.province && this.value.province.area_code === area_code) {
						this.provinceData.content = name
						this.cityData.list = cities.map(c => c.name)
					}

					cities.forEach(({ area_code: cityCode, name }) => {
						if (this.value && this.value.city && this.value.city.area_code === cityCode) {
							this.cityData.content = name
						}
					})
				})
			} catch (e) {}
		}
	}
}
</script>
<style lang="scss" scoped>
::v-deep {
	.list-ul {
		height: 450px;
		overflow-y: scroll;
	}

	.van-popup {
		> .container {
			position: relative !important;
			> .address {
				position: relative !important;
			}
		}
	}
}
</style>
